import { FC, memo } from "react";
import { Skeleton } from '@mui/material';
import { FileDescription, FileInfo, FileName } from "./files.styles";
import { LiSeparator, List, ListItem } from "../../patient-profile-widget.styles";
import { DotSeparatedSkeleton } from "../../shared/skeleton/dot-separated-skeleton";
import { randomBetween } from "../../utils/random-between";

export const FilesSkeleton: FC = memo(() => {
  const itemCount = 5;

  const fileItem = (key: number) => {
    return <>
      <ListItem key={key}>
        <FileInfo>
          <DotSeparatedSkeleton />
        </FileInfo>
        <FileName>
          <Skeleton variant="rounded" width={randomBetween(120, 180)} height={14} />
        </FileName>
        <FileDescription>
          <Skeleton variant="rounded" width={randomBetween(160, 240)} height={12} />
        </FileDescription>
      </ListItem>
      {key !== itemCount - 1 && <LiSeparator key={1000 + key} />}
    </>
  }

  return <List>
    {Array.from({ length: itemCount }, (_, index) => fileItem(index))}
  </List>
});